import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'Components/Atoms/IconButtonBare';
import clsx from 'clsx';
import OutlineArrowBottom from 'Components/Atoms/OutlineIcons/OutlineArrowBottom';
import Loading from 'Components/Atoms/Loading/Loading';

export default function InfinitePagination(props) {
    const { isFetching, fetchNextPage, hasNextPage, children } = props;

    const sentinelRef = useRef(null);

    useEffect(() => {
        if (sentinelRef.current) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !isFetching) {
                        fetchNextPage();
                    }
                });
            });

            observer.observe(sentinelRef.current);

            return () => {
                observer.disconnect();
            };
        }
    }, [sentinelRef, isFetching]);

    return (
        <>
            {children}

            <div className={clsx('flex justify-center', hasNextPage && 'mt-6')}>
                {hasNextPage &&
                    (isFetching ? (
                        <Loading size="small" />
                    ) : (
                        <IconButton variant="ghost" icon={<OutlineArrowBottom />} onClick={fetchNextPage} />
                    ))}
            </div>

            {hasNextPage && <div ref={sentinelRef} />}
        </>
    );
}

InfinitePagination.propTypes = {
    isFetching: PropTypes.bool.isRequired,
    fetchNextPage: PropTypes.func.isRequired,
    hasNextPage: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};
